var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretCircleDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2603_21144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3.46875C16.9706 3.46875 21 7.49819 21 12.4688C21 17.4393 16.9706 21.4688 12 21.4688C7.02944 21.4688 3 17.4393 3 12.4688C3 7.49819 7.02944 3.46875 12 3.46875Z",
    fill: "#1851B0",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 13.4688L12 9.46875L16 13.4688",
    stroke: "#1859B4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2603_21144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 24.4688)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretCircleDown);
export default __webpack_public_path__ + "static/media/CaretCircleDown.69e3f09c7004b1c83328fd3e46f7c0df.svg";
export { ForwardRef as ReactComponent };